import i18next from 'i18next';
import { AskPromptLanguage } from '../api/types';

/** The languages the app ships, which are the ones the gateway will answer in. */
const SUPPORTED_LANGUAGES: AskPromptLanguage[] = ['en', 'es', 'fr'];

/** What an unrecognised UI language falls back to, and what the gateway would have chosen anyway. */
const DEFAULT_LANGUAGE: AskPromptLanguage = 'en';

/**
 * The language the agent should answer in, as the `language` field of a `/prompt` request.
 *
 * Read from the UI language rather than guessed from the question: a user reading the app in
 * Spanish who types an English place name is still owed a Spanish answer. The region is cut off
 * (`en-GB` is `en`), because the gateway takes the language and not the locale.
 */
export function promptLanguage(): AskPromptLanguage {
  const shortCode = (i18next.language ?? DEFAULT_LANGUAGE).split('-')[0] as AskPromptLanguage;
  return SUPPORTED_LANGUAGES.includes(shortCode) ? shortCode : DEFAULT_LANGUAGE;
}
